<div>
  <div class="col-xs-12 col-sm-12 col-md-12">
    <div class="row d-flex align-items-center">
      <div class="col-md-12"><h4>Change College</h4></div>
    </div>
    <div class="row d-flex align-items-center mt-2" >
      <div class="col-md-12">Current College Name:</div>
      <div class="col-md-12"> <span style="font-weight: bold;"  class="text-info">{{currentCollegeName}}</span></div>
    </div>
    <div class="row d-flex align-items-center mt-3">
      <div class="col-md-12">Replace with </div></div>
    <div class="row d-flex align-items-center">
      <div class="col-md-12">
        <div *ngFor="let list of searchAutoCompleteList;let i=index;" class="d-flex align-items-center">
          <input type="radio" class="mr-1" [(ngModel)]="modelvalue" [value]="list.value" (ngModelChange)="onSelected(list,i)"   />
          <span style="font-weight: bold;">
            {{ list.value }}

          </span>

        </div>
        <!-- <div class="searchfilter">
          <ng-autocomplete class="mb-2"
         id="collesearch" [(ngModel)]="modelvalue"
          [data]="searchAutoCompleteList" searchKeyword="value"
          [itemTemplate]="itemTemplate"
          placeholder="Enter college name for search"
          (selected)='onSelected($event)'>
          </ng-autocomplete>
          <ng-template #itemTemplate let-item>
            <a  innerHTML="{{item.value}}, {{item.stateCode}}"> {{item.value}},{{item.stateCode}} </a>
          </ng-template>
          <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="notFound"></div>
          </ng-template>
        </div> -->
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col-md-12">
        <div class="col text-center" style="height: 30px">
          <!-- <tui-root> -->
              <img *ngIf="isLoadingData" src="https://cdn.virtueanalytics.com/cache/loader.gif" style="width: 30px; height:30px">
              <!-- <tui-loader [inheritColor]="true"> </tui-loader> -->
           <!-- </tui-root> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <app-autocomplete-search-box  [pageAnswer]="''" (selectChange)="selectCollege($event)"  [index]="''">
    </app-autocomplete-search-box> -->
 
  <!-- <button
    [disabled]="checkDisableNextBtn()"
    [ngClass]="checkDisableNextBtn() ? 'cursor-not-allowed' : ''"
    class="page-btn mt-4"
    (click)="changeCollege()"
  >
    Change
  </button> -->
  <div class="form-group row pt-3 text-center">
    <div class="col btn-section text-center mt-2">
        <a class="page-close-btn mx-1" (click)="close()">Close</a>
    </div>
  </div>
  
  
</div>
